import React, { useCallback } from "react";
import { Virtuoso } from "react-virtuoso";

type VirtualizedListProps<T> = {
  data: T[];
  width: number | string;
  height: number | string;
  renderRow: (item: T, index: number) => React.ReactNode;
  getKey: (item: T, index: number) => string | number;
  followOutput?: boolean | 'smooth' | 'auto';
};
//add in callback

function VirtualizedList<T>({
  data,
  width,
  height,
  renderRow,
  getKey,
  followOutput = false,
}: Omit<VirtualizedListProps<T>, "itemHeight">) {
  // Memoized itemContent function to prevent unnecessary re-renders
  const itemContent = useCallback(
    (index: number) => (
      <div key={getKey(data[index], index)}>
        {renderRow(data[index], index)}
      </div>
    ),
    [data, renderRow, getKey]
  );

  return (
    <Virtuoso
      style={{ height, width }}
      totalCount={data.length}
      itemContent={itemContent}
      initialTopMostItemIndex={data.length > 0 ? data.length - 1 : 0}
      followOutput={followOutput ? 'smooth' : false}
      alignToBottom
    />
  );
}

export default React.memo(VirtualizedList);
